// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-annotation-tool-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
}

.neuroglancer-annotation-tool-status::-webkit-scrollbar {
  display: none;
}

.neuroglancer-annotation-tool-status-widget
  + .neuroglancer-annotation-tool-status-widget {
  margin-left: 3px;
}

.neuroglancer-annotation-tool-status-widget:hover {
  outline: 1px solid #fff;
}

.neuroglancer-annotation-tool-status-widget {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.neuroglancer-annotation-tool-status-widget-layer-number {
  display: inline-block;
  font: 10pt sans-serif;
  font-weight: bold;
  background-color: #9a7518;
}

.neuroglancer-annotation-tool-status-widget-key {
  display: inline-block;
  font: 9pt monospace;
  color: #0ff;
}

.neuroglancer-annotation-tool-status-widget-key::before {
  content: "[";
}

.neuroglancer-annotation-tool-status-widget-key::after {
  content: "]";
}

.neuroglancer-annotation-tool-status-widget-key::before,
.neuroglancer-annotation-tool-status-widget-key::after {
  color: #999;
}

.neuroglancer-annotation-tool-status-widget-description {
  display: inline-block;
  color: #3c3;
  font: 10pt sans-serif;
  white-space: nowrap;
}

.neuroglancer-annotation-tool-status-widget-delete {
  visibility: hidden;
}

.neuroglancer-annotation-tool-status-widget:hover
  > .neuroglancer-annotation-tool-status-widget-delete {
  visibility: inherit;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/widget/annotation_tool_status.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":["/**\n * @license\n * Copyright 2018 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-annotation-tool-status {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow-x: scroll;\n  scrollbar-width: none;\n}\n\n.neuroglancer-annotation-tool-status::-webkit-scrollbar {\n  display: none;\n}\n\n.neuroglancer-annotation-tool-status-widget\n  + .neuroglancer-annotation-tool-status-widget {\n  margin-left: 3px;\n}\n\n.neuroglancer-annotation-tool-status-widget:hover {\n  outline: 1px solid #fff;\n}\n\n.neuroglancer-annotation-tool-status-widget {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.neuroglancer-annotation-tool-status-widget-layer-number {\n  display: inline-block;\n  font: 10pt sans-serif;\n  font-weight: bold;\n  background-color: #9a7518;\n}\n\n.neuroglancer-annotation-tool-status-widget-key {\n  display: inline-block;\n  font: 9pt monospace;\n  color: #0ff;\n}\n\n.neuroglancer-annotation-tool-status-widget-key::before {\n  content: \"[\";\n}\n\n.neuroglancer-annotation-tool-status-widget-key::after {\n  content: \"]\";\n}\n\n.neuroglancer-annotation-tool-status-widget-key::before,\n.neuroglancer-annotation-tool-status-widget-key::after {\n  color: #999;\n}\n\n.neuroglancer-annotation-tool-status-widget-description {\n  display: inline-block;\n  color: #3c3;\n  font: 10pt sans-serif;\n  white-space: nowrap;\n}\n\n.neuroglancer-annotation-tool-status-widget-delete {\n  visibility: hidden;\n}\n\n.neuroglancer-annotation-tool-status-widget:hover\n  > .neuroglancer-annotation-tool-status-widget-delete {\n  visibility: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
